export function replaceStationeryBodyWithContent(
  htmlContent: string,
  stationeryHtml: string | null
): string {
  let emailContent = htmlContent;
  if (stationeryHtml) {
    emailContent = stationeryHtml.replace("[EMAIL BODY]", htmlContent || "");
  }

  return emailContent;
}

/* !! IMPORTANT
 * The template head is expected to contain the placeholder "[Template Body]" which will be replaced with the email content.
 * If this placeholder is missing, the head will not be included in the file output and the email content will be returned as is.
 */
export function processTemplateHead(
  head: string | null,
  emailContent: string
): string {
  if (!head || !head.includes("[Template Body]")) return emailContent;

  const processedHead = head.replace("[Template Body]", emailContent);
  return processedHead;
}

export function replaceStationeryBodyWithContentAndHead(
  htmlContent: string,
  stationeryHtml: string | null,
  templateHead: string | null
): string {
  // First, apply existing stationery replacement
  let emailContent = replaceStationeryBodyWithContent(
    htmlContent,
    stationeryHtml
  );

  // Then, process template head if available
  if (templateHead) {
    emailContent = processTemplateHead(templateHead, emailContent);
  }

  return emailContent;
}
